import { Dayjs } from "dayjs"

export interface IPsrExtraData {
  field: string
  id: number
  value: string
}
export interface IPsrCustomerService {
  id: number
  startDate: Dayjs
  endDate?: Dayjs
  label: string
  availableNow: boolean
  alwaysOn: boolean
  extraData?: Array<IPsrExtraData>
}

export interface IPsrCustomerVulnerability {
  id: number
  startDate: Dayjs
  label: string
  endDate?: Dayjs
  note?: string
}

export interface IPsrCustomerSettings {
  customerServices: Array<IPsrCustomerService>
  customerVulnerabilities: Array<IPsrCustomerVulnerability>
}

export interface IPsrServiceCategory {
  id: number
  name: string
  description: string
  displayOrder: number
}

export interface IPsrPriorityService {
  id: number
  title: string
  label: string
  description: string
  alwaysOn: boolean
  availableNow: boolean
  serviceItems?: Array<IPsrPriorityServiceItem>
  isInternal?: boolean
  category?: IPsrServiceCategory
}

export const PsrPriorityServiceItemFieldTypes = {
  FIRST_NAME: "First name",
  LAST_NAME: "Last name",
  EMAIL: "Email",
  PHONE: "Phone",
  DOB: "Date of birth",
  IN_PERSON_PASSPHRASE: "In-person passphrase",
  PAPER_STATEMENT_TYPE: "Choose paper statement type",
} as const

export const IPsrPriorityServiceItemTypes = {
  SELECT: "select",
  SELECT_ITEM: "select-item",
  TEXT: "text",
  DATE: "date",
} as const

export type PsrPriorityServiceItemType =
  (typeof IPsrPriorityServiceItemTypes)[keyof typeof IPsrPriorityServiceItemTypes]

export type PsrPriorityServiceItemFieldType =
  (typeof PsrPriorityServiceItemFieldTypes)[keyof typeof PsrPriorityServiceItemFieldTypes]

export interface IPsrPriorityServiceItem {
  displayOrder: number
  description: PsrPriorityServiceItemFieldType
  id: number
  name: string
  placeholder?: string
  required: boolean
  type: PsrPriorityServiceItemType
  label: string
}

export interface IPsrVulnerability {
  id: number
  label: string
  description: string
  requiresEndDate: boolean
}

export const ENGLISH_AS_SECOND_LANGUAGE_LABEL = "English as a second language"
